module.exports = __webpack_public_path__ + "static/img/illustratepic_01.9dc0ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ko/illustratepic_01.png
// module id = /v8i
// module chunks = 1